var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"z-index":"7"}},[_c('v-progress-linear',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"loader",attrs:{"data-test":"progress","indeterminate":"","absolute":"","color":"primary darken-2 "}}),_c('v-overlay',{attrs:{"data-test":"overlay","value":_vm.overlayInLoading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }